import React from 'react';

import {
  descriptionSchema,
  descriptionUI,
  titleUI,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import fullSchema from '../../schema';
import ConfirmationPrisonerOfWar from '../../components/confirmationFields/ConfirmationPrisonerOfWar';

// Section V Item 13 — POW status. Shown when the Veteran is claiming at least
// one condition with cause type NEW or SECONDARY (page-level `depends` in the form
// config). A "yes" answer routes to the POW era/campaign page; "no" skips it.
export default {
  uiSchema: {
    'ui:confirmationField': ConfirmationPrisonerOfWar,
    ...titleUI('Prisoner of war (POW)'),
    powStatus: yesNoUI({
      title: 'Have you ever been a prisoner of war?',
      errorMessages: {
        required: 'You must select a response',
      },
    }),
    'view:powNote': descriptionUI(
      <p>
        <strong>Note:</strong> If you’ve been a POW, we’ll ask you for more
        information next. We’ll use this information to process your claim.
      </p>,
    ),
  },
  schema: {
    type: 'object',
    required: ['powStatus'],
    properties: {
      powStatus: fullSchema.properties.powStatus,
      'view:powNote': descriptionSchema,
    },
  },
};
